import { render } from "./ServiciosList.vue?vue&type=template&id=081a7fb2&scoped=true"
import script from "./ServiciosList.vue?vue&type=script&lang=js"
export * from "./ServiciosList.vue?vue&type=script&lang=js"

import "./ServiciosList.vue?vue&type=style&index=0&id=081a7fb2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081a7fb2"]])

export default __exports__